<template>
  <div class="text-left">
    <div>
      <el-button type="text" class="h5" v-show="display.mode === 2" @click="display.mode = 1">>>> 图表模式</el-button>
      <el-button type="text" class="h5" v-show="display.mode === 1" @click="display.mode = 2">>>> 表格模式</el-button>
    </div>
    <div v-if="display.mode === 1" style="min-width: 900px">
      <percentage-pie class="mb-5"/>
      <statistical-bar @changeTheme="changeTheme" class="mb-5"/>
      <money-statistical class="mb-5"/>
      <city-rank/>
    </div>
    <el-card class="box-card mt-3 m-auto" style="width: 940px" v-if="display.mode === 2">
      <travel-table/>
    </el-card>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import TravelTable from './TravelCompos/TravelTable'
  import PercentagePie from './TravelCompos/PercentagePie'
  import StatisticalBar from './TravelCompos/StatisticalBar'
  import MoneyStatistical from './TravelCompos/MoneyStatistical'
  import CityRank from './TravelCompos/CityRank'

  export default {
    name: 'TravelChart',
    components: {TravelTable, PercentagePie, StatisticalBar, MoneyStatistical, CityRank},
    computed: {
      ...mapState(['StoreChartLists']),
    },
    data() {
      return {
        display: {mode: 1, theme: ''}
      }
    },
    watch: {
      display: {
        handler(val) {
          this.$emit('changeDisplay', val);
        },
        deep: true
      }
    },
    methods: {
      changeTheme(theme) {
        this.display.theme = theme;
      }
    }
  }
</script>
